"use client";

import { CreditCard, Mail, User } from "lucide-react";
import { Dispatch, SetStateAction } from "react";

import { CartItem } from "./types";
import { CheckoutModalLayout } from "./CheckoutModalLayout";
import { ShowInfo } from "@punchup/data/legacy";

interface Props {
  show: ShowInfo;
  cart: CartItem[];
  comedianNames: string[];
  activeStep: number;
  setActiveStep: Dispatch<SetStateAction<number>>;
  setSuccess: Dispatch<SetStateAction<boolean>>;
}

export const FastCheckoutConfirmation = ({
  show,
  cart,
  comedianNames,
  activeStep,
  setActiveStep,
  setSuccess,
}: Props) => {
  const onPurchaseClick = () => {
    // TODO: place the order, etc.
    // increment the step index
    setActiveStep((prev) => prev + 1);
    setSuccess(true);
  };

  const handleChangeClick = () => {
    // go back to the previous step
    setActiveStep((prev) => prev - 1);
  };

  const fullName = "John Doe";
  const email = "john.doe@example.com";
  const fullAddress = "245 West 38th Street, New York, NY 10018, United States";

  return (
    <CheckoutModalLayout
      show={show}
      cart={cart}
      comedianNames={comedianNames}
      activeStep={activeStep}
      setActiveStep={setActiveStep}
      title="Confirm and pay"
      subtitle="The tickets will be sent to your email."
      buttonLabel="Purchase"
      buttonDisabled={false}
      onButtonClick={onPurchaseClick}
    >
      <div className="flex-1 flex flex-col gap-6 text-primary-blue">
        <div className="flex flex-row justify-between items-start">
          <div className="flex flex-row gap-2.5 w-full">
            <div className="flex items-start justify-center mt-[1px]">
              <User className="w-6 h-6 text-primary-blue" />
            </div>
            <div className="text-[14px]">
              <p className="font-semibold">Your info</p>
              <p className="text-secondary-blue font-light">{fullName}</p>
              <p className="text-secondary-blue font-light">{email}</p>
            </div>
          </div>
          <ChangeButton onClick={handleChangeClick} />
        </div>
        <div className="flex flex-row justify-between items-start">
          <div className="flex flex-row gap-2.5 w-full">
            <div className="flex items-start justify-center mt-[1px]">
              <Mail className="w-6 h-6 text-primary-blue" />
            </div>
            <div className="text-[14px]">
              <p className="font-semibold">Billing info</p>
              <p className="text-secondary-blue font-light">{fullAddress}</p>
            </div>
          </div>
          <ChangeButton onClick={handleChangeClick} />
        </div>
        <div className="flex flex-row justify-between items-start">
          <div className="flex flex-row gap-2.5 w-full">
            <div className="flex items-start justify-center mt-[1px]">
              <CreditCard className="w-6 h-6 text-primary-blue" />
            </div>
            <div className="text-[14px]">
              <p className="font-semibold">Your card</p>
              <p className="text-secondary-blue font-light">
                Visa ending in 1234
              </p>
            </div>
          </div>
          <ChangeButton onClick={handleChangeClick} />
        </div>
      </div>
    </CheckoutModalLayout>
  );
};

const ChangeButton = ({ onClick }: { onClick: () => void }) => {
  return (
    <button
      onClick={onClick}
      className="text-[14px] font-medium text-primary underline underline-offset-2 mt-0.5"
    >
      Change
    </button>
  );
};
